import { render, staticRenderFns } from "./CreateWorkspace.vue?vue&type=template&id=d2214544"
import script from "./CreateWorkspace.vue?vue&type=script&lang=js"
export * from "./CreateWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports